import { Controller as BaseController } from 'stimulus'
import './index.scss'

export class Controller extends BaseController {
  static targets = ['toggleButton', 'additionalListItem']

  toggleAllItems() {
    this.additionalListItemTargets.forEach(item => item.toggleAttribute('hidden'))
  }
}
